import React, { useContext, useEffect } from "react";
import { closeLayerFn, pickerEndFn2 } from "../../Layout";


export const AfterMealInputLayer2 = (props) => {
    const { evnetHandler } = props;

    useEffect(() => {
        $(".aftermeal-input-layer .tbns-area a").click(function () {
            //확인버튼일 경우 선택값 적용
            let mealTypeInValue = "B";
            let hourInvalue = $(".pickslide-afhour .swiper-slide-active span").html();
            let minInvalue = $(".pickslide-afminute .swiper-slide-active span").html();
            
            if ($(this).hasClass("wht")) {
                if($(".pickslide-after .swiper-slide-active span").html() === "식사 전") {
                    mealTypeInValue = "B";
                } else {
                    mealTypeInValue = "A"
                }

                $(".pick-result2").val(
                    $(".pickslide-after .swiper-slide-active span").html() + " " + hourInvalue + ":" + minInvalue
                );

                evnetHandler($("#targetKey").val(), mealTypeInValue, (hourInvalue + '' + minInvalue));

            }
            pickerEndFn2();
            closeLayerFn($(".aftermeal-input-layer"));
        });
    }, []);

    return (
        <div className="blacklayer-container aftermeal-input-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box vertical">
                    <div className="blgr-title">일시 설정</div>

                    <div className="picker-container w3">
                        <div className="swiper-container pickslide-after">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <span className="meal-txt">식사 후</span>
                                </div>
                                <div className="swiper-slide">
                                    <span className="meal-txt">식사 전</span>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-container pickslide-afhour">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <span>00</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>01</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>02</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>03</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>04</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>05</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>06</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>07</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>08</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>09</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>10</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>11</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>12</span>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-container pickslide-afminute">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <span>00</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>05</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>10</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>15</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>20</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>25</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>30</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>35</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>40</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>45</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>50</span>
                                </div>
                                <div className="swiper-slide">
                                    <span>55</span>
                                </div>
                            </div>
                        </div>
                        <i className="dots"></i>
                    </div>

                    <div className="tbns-area">
                        <input type="hidden" id="targetKey" />
                        <a href={void 0} className="btn-round gray">
                            취소
                        </a>
                        <a href={void 0} className="btn-round wht">
                            확인
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
